import module from 'module';
import AccessType from 'constants/customerAccessType';

module.component('customerNongroupAccess', {
  template: '<customer-access access-type="$ctrl.type"></customer-access>',
  controller: function() {
    this.type = AccessType.NONGROUP;
  }
});